export const SET_CREWS = 'SET_CREWS';
export const SET_CREW = 'SET_CREW';
export const ADD_CREW = 'ADD_CREW';
export const UPDATE_CREW = 'UPDATE_CREW';
export const REMOVE_CREW = 'REMOVE_CREW';
export const CLEAR_CREW = 'CLEAR_CREW';
export const CLEAR_CREWS = 'CLEAR_CREWS';
